export default __webpack_public_path__ + "static/media/Summer_Schrader_Product_Design_Lead.3fcd9c1a.pdf";